import { motion } from "framer-motion";
import { useTenantTranslation } from "hooks/formatters";
import { SelectBox } from "components/strategyDashboard/Selectbox";
import { useChemistryElement } from "./ChemistryElementContext";

export const ChemistryElementDropdown = () => {
  const { t } = useTenantTranslation();
  const { selectedElement, setSelectedElement, availableElements } =
    useChemistryElement();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <SelectBox
        availableOptions={availableElements}
        selectedOption={selectedElement ?? null}
        onOptionChange={setSelectedElement}
        id="chemistry-element-select"
        labelId="chemistry-element-select-label"
        label={t("element")}
      />
    </motion.div>
  );
};
